module.exports = __webpack_public_path__ + "biao20.gif?1e58644";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao20.gif
 ** module id = 56
 ** module chunks = 0
 **/